export class progressBarConstants {
	public static welcomeScreen = 10;
	public static firstQuestion = 20;
	public static uploadFiles = 95;
	public static questionnaireEnd = 100;
	public static firstQuestionStart = this.welcomeScreen + this.firstQuestion;
}
